// The 8 app-preview modals. Each key opens the REAL sandbox demo worker in an
// iframe (separate from prod, DEMO-gated, zero prod bindings). Their CSP
// frame-ancestors already allow grstnhbr.com + *.grstnhbr.com + workers.dev, so
// they frame from every site host. Keep this map in sync with CONTEXT §3.

export type ModalType = "phone" | "desktop";

export type ModalKey =
  | "turnaround"
  | "drop"
  | "pay"
  | "downloads"
  | "negativ"
  | "pickups"
  | "invoices"
  | "allorders";

export type ModalConfig = { url: string; type: ModalType; label: string };

export const MODALS: Record<ModalKey, ModalConfig> = {
  turnaround: {
    url: "https://turnaround.sandbox.atxfilmlab.com/?demo=customer@example.net",
    type: "phone",
    label: "turnaround",
  },
  drop: { url: "https://drop.sandbox.atxfilmlab.com/?demo=1", type: "phone", label: "drop" },
  pay: { url: "https://pay.sandbox.atxfilmlab.com/?demo=1", type: "phone", label: "pay" },
  downloads: {
    url: "https://downloads.sandbox.atxfilmlab.com/?demo=1",
    type: "phone",
    label: "downloads",
  },
  negativ: {
    url: "https://demo.club.atxfilmlab.com/customers/turbo_butterball",
    type: "phone",
    label: "negativ",
  },
  pickups: {
    url: "https://pickups.sandbox.atxfilmlab.com/?demo=1",
    type: "phone",
    label: "unified-pickup",
  },
  invoices: { url: "https://invoices.sandbox.atxfilmlab.com/", type: "desktop", label: "invoices" },
  allorders: {
    url: "https://allorders.sandbox.atxfilmlab.com/",
    type: "desktop",
    label: "all-orders",
  },
};

export function prettyHost(u: string): string {
  return u.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
}
